import { ControlInstance } from "../instance";
class SlotControl extends ControlInstance {
  static CONTAINER_BOX_MODEL_CHANGE = "makeswift::controls::slot::message::container-box-model-change";
  static ITEM_BOX_MODEL_CHANGE = "makeswift::controls::slot::message::item-box-model-change";
  recv = (_message) => {
  };
  child(_key) {
    return void 0;
  }
  changeContainerBoxModel(boxModel) {
    this.sendMessage({
      type: SlotControl.CONTAINER_BOX_MODEL_CHANGE,
      payload: { boxModel }
    });
  }
  changeItemBoxModel(index, boxModel) {
    this.sendMessage({
      type: SlotControl.ITEM_BOX_MODEL_CHANGE,
      payload: { index, boxModel }
    });
  }
}
export {
  SlotControl
};
//# sourceMappingURL=slot-control.js.map